module.exports = __webpack_public_path__ + "static/media/404.acd39b6b.png";